import React, { HTMLAttributes } from "react"

interface SVGComponent extends HTMLAttributes<HTMLOrSVGElement> {}

export const PhoneIcon = ({
  modifier = "",
  customClassName = "",
}: {
  modifier?: string
  customClassName?: string
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.99"
    height="14.25"
    viewBox="0 0 12.99 14.25"
    className={`${customClassName ? customClassName : `phone-svg${modifier}`}`}
  >
    <path
      id="Path_14723"
      data-name="Path 14723"
      d="M20112.426,23388.25a10.4,10.4,0,0,1-8.059-3.937,13.1,13.1,0,0,1-2.773-5.977,8.814,8.814,0,0,1,.125-3.816,8.977,8.977,0,0,1,3.076-.52c.234,0,.469.008.678.027a7.087,7.087,0,0,1,.646,3.973,11.006,11.006,0,0,1-1.732,1.07l-.373.164.057.41a9.948,9.948,0,0,0,4.58,5.57l.391.133.234-.332a10.611,10.611,0,0,1,1.385-1.492,6.426,6.426,0,0,1,2.041.445,6.753,6.753,0,0,1,1.738.961,6.936,6.936,0,0,1-.924,3.262A10.381,10.381,0,0,1,20112.426,23388.25Z"
      transform="translate(-20101.449 -23374)"
      fill="#fff"
    />
  </svg>
)

export const getPhoneIcon = (modifier = "", customClassName = "") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      className={`${
        customClassName ? customClassName : `phone-svg${modifier}`
      }`}
    >
      <g
        id="phone_icon"
        data-name="phone/icon"
        transform="translate(-150 -12.608)"
      >
        <g id="icon" transform="translate(150 12.607)">
          <path
            id="Path_16312"
            data-name="Path 16312"
            d="M30.169,13.343A25.132,25.132,0,0,0,16.836.074a.96.96,0,0,0-1.264.552,1.012,1.012,0,0,0,.534,1.3A23.169,23.169,0,0,1,28.4,14.163a.971.971,0,0,0,.886.592.936.936,0,0,0,.4-.089,1.015,1.015,0,0,0,.488-1.324"
            transform="translate(-0.254 0)"
            fill="#fff"
          />
          <path
            id="Path_16313"
            data-name="Path 16313"
            d="M15.585,7.362a14.034,14.034,0,0,1,7.456,7.4.938.938,0,0,0,.857.57.9.9,0,0,0,.384-.085.976.976,0,0,0,.471-1.277,15.929,15.929,0,0,0-8.461-8.4.929.929,0,0,0-1.223.532.976.976,0,0,0,.516,1.258"
            transform="translate(-0.246 -0.09)"
            fill="#fff"
          />
          <path
            id="Path_16314"
            data-name="Path 16314"
            d="M24.816,18.96a2.287,2.287,0,0,0-3.457,0c-.809.8-1.615,1.6-2.411,2.418a.551.551,0,0,1-.389.209.567.567,0,0,1-.277-.087c-.522-.285-1.079-.516-1.582-.828a25.057,25.057,0,0,1-6.047-5.5A14.349,14.349,0,0,1,8.487,11.7a.5.5,0,0,1,.123-.638c.808-.781,1.6-1.583,2.391-2.384a2.3,2.3,0,0,0-.007-3.539c-.631-.638-1.264-1.263-1.9-1.9-.652-.652-1.3-1.311-1.956-1.956A2.483,2.483,0,0,0,5.414.5a2.461,2.461,0,0,0-1.728.786c-.816.8-1.6,1.623-2.426,2.411A3.935,3.935,0,0,0,.024,6.353,11.237,11.237,0,0,0,.894,11.2a29.41,29.41,0,0,0,5.223,8.7,32.308,32.308,0,0,0,10.7,8.375A15.465,15.465,0,0,0,22.751,30c.129.008.256.011.381.011a4.233,4.233,0,0,0,3.349-1.43c.692-.774,1.473-1.48,2.208-2.221a2.312,2.312,0,0,0,.014-3.518q-1.937-1.946-3.886-3.878m2.476,6.012c-.243.245-.491.485-.738.726-.51.495-1.038,1.007-1.54,1.571a2.294,2.294,0,0,1-1.883.772c-.089,0-.179,0-.272-.008a13.341,13.341,0,0,1-5.178-1.53A30.514,30.514,0,0,1,7.622,18.63,27.335,27.335,0,0,1,2.735,10.5a9.237,9.237,0,0,1-.751-4,1.981,1.981,0,0,1,.632-1.384c.511-.487,1-.986,1.5-1.485.314-.317.629-.634.952-.952a.64.64,0,0,1,.346-.218.656.656,0,0,1,.352.217c.433.424.86.854,1.287,1.285l.648.649c.322.326.643.647.964.969s.622.621.933.936c.364.365.341.429.006.767l-.331.335c-.673.68-1.345,1.356-2.055,2.043a2.45,2.45,0,0,0-.544,2.791,16.065,16.065,0,0,0,2.455,3.952,26.914,26.914,0,0,0,6.532,5.929,12.477,12.477,0,0,0,1.122.6c.187.092.375.184.532.269a2.505,2.505,0,0,0,1.244.341,2.465,2.465,0,0,0,1.8-.8c.777-.8,1.567-1.58,2.389-2.4a.646.646,0,0,1,.339-.217.651.651,0,0,1,.344.217q1.942,1.931,3.877,3.87c.3.3.33.4-.015.748"
            transform="translate(0 -0.008)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  )
}

export const getLoginIcon = ({ ...rest }: SVGComponent) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20.003"
      viewBox="0 0 20 20.003"
      {...rest}
    >
      <g id="icon" transform="translate(-2.627 -0.001)" opacity="1">
        <path
          id="Path_14710"
          data-name="Path 14710"
          d="M17.467,20H1.489a.891.891,0,0,1,0-1.766h15.2V1.766H1.489A.832.832,0,0,1,.717.885.835.835,0,0,1,1.489,0H17.467a.84.84,0,0,1,.775.885V19.118a.84.84,0,0,1-.775.885"
          transform="translate(4.384 0.001)"
          fill="#fff"
        />
        <path
          id="Path_14711"
          data-name="Path 14711"
          d="M13.872,4.384H.757A.829.829,0,0,1,0,3.5a.825.825,0,0,1,.757-.881H13.872a.827.827,0,0,1,.755.881.83.83,0,0,1-.755.885"
          transform="translate(2.627 6.361)"
          fill="#fff"
        />
        <path
          id="Path_14712"
          data-name="Path 14712"
          d="M4.408,11.025a.883.883,0,0,1-.624-1.509L7.059,6.241,3.808,2.994A.884.884,0,0,1,5.056,1.742L8.931,5.617a.884.884,0,0,1,0,1.252l-3.9,3.9a.88.88,0,0,1-.624.257"
          transform="translate(8.73 3.608)"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

export const BurgerIcon = ({ ...rest }: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="37"
    viewBox="0 0 45 37"
    {...rest}
  >
    <g id="hamburger" transform="translate(2.5 2.5)">
      <line
        id="bottom"
        data-name="bottom"
        x2="40"
        transform="translate(0 32)"
        fill="none"
        stroke="#626b5d"
        strokeLinecap="round"
        strokeWidth="5"
        className="fr-menu__rect"
      />
      <line
        id="middle"
        data-name="middle"
        x2="40"
        transform="translate(0 16)"
        fill="none"
        stroke="#626b5d"
        strokeLinecap="round"
        strokeWidth="5"
        className="fr-menu__rect"
      />
      <line
        id="top"
        data-name="top"
        x2="40"
        fill="none"
        stroke="#626b5d"
        strokeLinecap="round"
        strokeWidth="5"
        className="fr-menu__rect"
      />
    </g>
  </svg>
)

export const SideNavCloseIcon = ({ ...rest }: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.274"
    height="22.274"
    viewBox="0 0 22.274 22.274"
    {...rest}
  >
    <g id="close" transform="translate(-21.894 -11.25)">
      <g id="icon">
        <rect
          id="bottom"
          width="28"
          height="3.5"
          transform="translate(21.895 31.049) rotate(-45)"
          fill="#017bca"
        />
        <rect
          id="top"
          width="28"
          height="3.5"
          transform="translate(24.369 11.25) rotate(45)"
          fill="#017bca"
        />
      </g>
    </g>
  </svg>
)

export const OverlayCloseIcon = ({ ...rest }: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 35.355 35.355"
    {...rest}
  >
    <g
      id="Group_2662"
      data-name="Group 2662"
      transform="translate(3.535 -10.465)"
    >
      <line
        id="Line_56"
        data-name="Line 56"
        x2="40"
        transform="translate(0 42.284) rotate(-45)"
        fill="none"
        stroke="#626b5d"
        stroke-linecap="round"
        stroke-width="5"
      />
      <line
        id="Line_55"
        data-name="Line 55"
        x2="40"
        transform="translate(0 13.999) rotate(45)"
        fill="none"
        stroke="#626b5d"
        stroke-linecap="round"
        stroke-width="5"
      />
    </g>
  </svg>
)

export const CTAChevron = ({ ...rest }: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.677"
    height="27.279"
    viewBox="0 0 19.677 27.279"
    {...rest}
  >
    <g id="arrow" transform="translate(0)">
      <path
        id="Path_14617"
        data-name="Path 14617"
        d="M75.526,12.216h0L63.9.589a2.013,2.013,0,0,0-2.847,2.847l10.2,10.2-10.2,10.2A2.013,2.013,0,0,0,63.9,26.69L75.526,15.063a2.013,2.013,0,0,0,0-2.847"
        transform="translate(-56.439)"
        fill="#fff"
      />
      <path
        id="Path_14618"
        data-name="Path 14618"
        d="M9.649,88.462h0l-6.191-6.19A2.013,2.013,0,0,0,.611,85.118l4.767,4.766L.59,94.673A2.013,2.013,0,0,0,3.437,97.52l6.212-6.212a2.012,2.012,0,0,0,0-2.847"
        transform="translate(0 -76.246)"
        fill="#fff"
      />
    </g>
  </svg>
)

export const DropdownChevron = ({ ...rest }: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.239"
    height="16.43"
    viewBox="0 0 10.239 16.43"
    {...rest}
  >
    <g id="arrow" transform="translate(0 -5.435)">
      <path
        id="Path_14618"
        data-name="Path 14618"
        d="M9.649,88.462h0l-6.191-6.19A2.013,2.013,0,0,0,.611,85.118l4.767,4.766L.59,94.673A2.013,2.013,0,0,0,3.437,97.52l6.212-6.212a2.012,2.012,0,0,0,0-2.847"
        transform="translate(0 -76.246)"
        fill="#fff"
      />
    </g>
  </svg>
)

export const ButtonChevron = () => (
  <svg
    id="button-arrow"
    xmlns="http://www.w3.org/2000/svg"
    width="19.677"
    height="27.279"
    viewBox="0 0 19.677 27.279"
  >
    <path
      id="Path_14617"
      className="button-arrow__path"
      data-name="Path 14617"
      d="M75.526,12.216h0L63.9.589a2.013,2.013,0,0,0-2.847,2.847l10.2,10.2-10.2,10.2A2.013,2.013,0,0,0,63.9,26.69L75.526,15.063a2.013,2.013,0,0,0,0-2.847"
      transform="translate(-56.439)"
      fill="#626b5d"
    />
    <path
      id="Path_14618"
      className="button-arrow__path"
      data-name="Path 14618"
      d="M9.649,88.462h0l-6.191-6.19A2.013,2.013,0,0,0,.611,85.118l4.767,4.766L.59,94.673A2.013,2.013,0,0,0,3.437,97.52l6.212-6.212a2.012,2.012,0,0,0,0-2.847"
      transform="translate(0 -76.246)"
      fill="#626b5d"
    />
  </svg>
)

export const LeftChevron = ({ ...rest }: SVGComponent) => {
  return (
    <svg
      id="left-chevron-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 16.91 23.444"
      {...rest}
    >
      <path
        id="Path_14617"
        data-name="Path 14617"
        d="M60.969,10.5h0L70.962.506a1.73,1.73,0,0,1,2.447,2.447L64.64,11.721l8.768,8.77a1.73,1.73,0,0,1-2.447,2.447l-9.992-9.993a1.73,1.73,0,0,1,0-2.447"
        transform="translate(-60.463)"
        fill="#626b5d"
        className="icon-path"
      />
      <path
        id="Path_14618"
        data-name="Path 14618"
        d="M.507,87.508h0l5.32-5.32a1.73,1.73,0,0,1,2.447,2.447l-4.1,4.1,4.115,4.116a1.73,1.73,0,1,1-2.446,2.447L.508,89.955a1.729,1.729,0,0,1,0-2.447"
        transform="translate(8.11 -77.01)"
        fill="#626b5d"
        className="icon-path"
      />
    </svg>
  )
}

export const RightChevron = ({ ...rest }: SVGComponent) => {
  return (
    <svg
      id="right-chevron-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 16.91 23.444"
      {...rest}
    >
      <path
        id="Path_14617"
        data-name="Path 14617"
        d="M73.408,10.5h0L63.416.506a1.73,1.73,0,0,0-2.447,2.447l8.768,8.768-8.768,8.77a1.73,1.73,0,1,0,2.447,2.447l9.992-9.992a1.73,1.73,0,0,0,0-2.447"
        transform="translate(-57.005 0)"
        fill="#626b5d"
        className="icon-path"
      />
      <path
        id="Path_14618"
        data-name="Path 14618"
        d="M8.293,87.508h0l-5.32-5.32A1.73,1.73,0,0,0,.525,84.635l4.1,4.1L.507,92.847a1.73,1.73,0,0,0,2.446,2.447l5.339-5.338a1.729,1.729,0,0,0,0-2.447"
        transform="translate(0 -77.01)"
        fill="#626b5d"
        className="icon-path"
      />
    </svg>
  )
}

export const BestOfferIcon = ({ ...rest }: SVGComponent) => {
  return (
    <svg
      id="best-offer-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="76.125"
      height="58.579"
      viewBox="0 0 76.125 58.579"
      {...rest}
    >
      <g
        id="best_offer_icon"
        data-name="best offer icon"
        transform="translate(0 7.528)"
      >
        <g id="Group_41" data-name="Group 41" transform="translate(0 -7.528)">
          <path
            id="Path_15867"
            data-name="Path 15867"
            d="M73.236,29.336l2.889-8.178H66.207a29.3,29.3,0,0,0-56.289,0H0l2.889,8.178L0,37.322H9.888a29.3,29.3,0,0,0,56.349,0h9.888Z"
            fill="#2f4858"
          />
          <path
            id="Path_15868"
            data-name="Path 15868"
            d="M148.41,62.262A23.882,23.882,0,1,1,124.528,38.38,23.882,23.882,0,0,1,148.41,62.262"
            transform="translate(-86.465 -32.972)"
            fill="#7ea1ab"
          />
          <path
            id="Path_15869"
            data-name="Path 15869"
            d="M120.115,82.455a24.606,24.606,0,1,1,24.606-24.606,24.634,24.634,0,0,1-24.606,24.606m0-47.764a23.158,23.158,0,1,0,23.158,23.158,23.185,23.185,0,0,0-23.158-23.158"
            transform="translate(-82.052 -28.559)"
            fill="#fff"
          />
          <path
            id="Path_15870"
            data-name="Path 15870"
            d="M15814.33,17857.779a3.6,3.6,0,0,1-1.24-.82,3.676,3.676,0,0,1-.8-1.252,4.513,4.513,0,0,1,0-3.168,3.687,3.687,0,0,1,.8-1.246,3.606,3.606,0,0,1,1.24-.822,4.435,4.435,0,0,1,3.16,0,3.7,3.7,0,0,1,1.24.822,3.761,3.761,0,0,1,.809,1.246,4.571,4.571,0,0,1,0,3.168,3.631,3.631,0,0,1-2.049,2.072,4.407,4.407,0,0,1-3.16,0Zm.5-6.219a2.488,2.488,0,0,0-.846.582,2.641,2.641,0,0,0-.557.881,3.1,3.1,0,0,0,0,2.2,2.575,2.575,0,0,0,.557.879,2.55,2.55,0,0,0,.846.588,2.866,2.866,0,0,0,2.158,0,2.657,2.657,0,0,0,.852-.588,2.537,2.537,0,0,0,.553-.879,3.055,3.055,0,0,0,.2-1.1,3.094,3.094,0,0,0-.2-1.1,2.623,2.623,0,0,0-.553-.877,2.672,2.672,0,0,0-.852-.582,2.942,2.942,0,0,0-2.158,0Zm29.047,6.344a.651.651,0,0,1-.24-.232l-1.586-2.559c-.033,0-.066,0-.1,0h-1.074v2.225a.622.622,0,0,1-.18.451.606.606,0,0,1-.455.184.621.621,0,0,1-.635-.635v-6.428a.609.609,0,0,1,.186-.457.616.616,0,0,1,.449-.178h1.709a2.76,2.76,0,0,1,1.33.316,2.315,2.315,0,0,1,.914.873,2.489,2.489,0,0,1,.328,1.287,2.3,2.3,0,0,1-.328,1.223,2.272,2.272,0,0,1-.881.82l1.369,2.2a.641.641,0,0,1,.053.66.577.577,0,0,1-.553.314A.668.668,0,0,1,15843.881,17857.9Zm.781-.473v-.01Zm-3.781-3.508h1.074a1.538,1.538,0,0,0,.705-.152,1.155,1.155,0,0,0,.467-.412,1.1,1.1,0,0,0,.168-.605,1.268,1.268,0,0,0-.17-.668,1.2,1.2,0,0,0-.469-.451,1.41,1.41,0,0,0-.7-.166h-1.074Zm-7.285,4.051a.614.614,0,0,1-.449-.182.623.623,0,0,1-.182-.453v-6.43a.606.606,0,0,1,.184-.455.619.619,0,0,1,.447-.18h4.295a.613.613,0,0,1,.447.168.589.589,0,0,1,.178.439.558.558,0,0,1-.178.426.635.635,0,0,1-.447.16h-3.66v2.027h2.588a.616.616,0,0,1,.447.168.611.611,0,0,1,0,.857.609.609,0,0,1-.447.168h-2.588v2.094h3.66a.642.642,0,0,1,.447.158.569.569,0,0,1,.178.428.581.581,0,0,1-.178.438.605.605,0,0,1-.447.168Zm-6.984-.182a.625.625,0,0,1-.184-.453v-6.43a.608.608,0,0,1,.186-.455.62.62,0,0,1,.449-.18h4.293a.624.624,0,0,1,.449.168.594.594,0,0,1,.176.439.558.558,0,0,1-.178.426.635.635,0,0,1-.447.16h-3.658v2.027h2.584a.629.629,0,0,1,.451.168.616.616,0,0,1,0,.857.621.621,0,0,1-.451.168h-2.584v2.65a.625.625,0,0,1-.184.453.613.613,0,0,1-.451.182A.622.622,0,0,1,15826.611,17857.793Zm-5.937,0a.631.631,0,0,1-.182-.453v-6.43a.614.614,0,0,1,.184-.455.625.625,0,0,1,.451-.18h4.291a.626.626,0,0,1,.451.168.586.586,0,0,1,.174.439.558.558,0,0,1-.178.426.625.625,0,0,1-.447.16h-3.656v2.027h2.584a.621.621,0,0,1,.449.168.606.606,0,0,1,0,.857.613.613,0,0,1-.449.168h-2.584v2.65a.619.619,0,0,1-.186.453.611.611,0,0,1-.449.182A.626.626,0,0,1,15820.674,17857.793Zm9.945-8.59a3.191,3.191,0,0,1-1.025-.57,2.25,2.25,0,0,1-.652-.857.582.582,0,0,1,.01-.568.679.679,0,0,1,.477-.318.6.6,0,0,1,.146-.018.7.7,0,0,1,.336.09.794.794,0,0,1,.342.365,1.043,1.043,0,0,0,.314.359,1.882,1.882,0,0,0,.566.289,2.349,2.349,0,0,0,1.482-.014,1.317,1.317,0,0,0,.533-.357.751.751,0,0,0,.186-.527,1.023,1.023,0,0,0-.33-.752,1.888,1.888,0,0,0-1.168-.434,3.5,3.5,0,0,1-1.971-.746,2.029,2.029,0,0,1-.748-1.592,1.86,1.86,0,0,1,.4-1.2,2.381,2.381,0,0,1,1.043-.729,3.975,3.975,0,0,1,1.42-.244,3.108,3.108,0,0,1,1.084.174,2.7,2.7,0,0,1,.82.486,3.117,3.117,0,0,1,.6.721.8.8,0,0,1,.141.533.6.6,0,0,1-.281.443.66.66,0,0,1-.352.105.678.678,0,0,1-.213-.037.735.735,0,0,1-.437-.344,1.4,1.4,0,0,0-.77-.67,1.76,1.76,0,0,0-.625-.1h-.043a2.042,2.042,0,0,0-1.025.234.678.678,0,0,0-.371.645.869.869,0,0,0,.123.443.952.952,0,0,0,.449.363,3.252,3.252,0,0,0,1.063.248,3.211,3.211,0,0,1,1.883.744,2.159,2.159,0,0,1,.7,1.67,2.134,2.134,0,0,1-.25,1.043,2.223,2.223,0,0,1-.658.736,2.954,2.954,0,0,1-.922.438,4.016,4.016,0,0,1-1.049.139A3.784,3.784,0,0,1,15830.619,17849.2Zm6.721-.1a.684.684,0,0,1-.205-.5v-5.8h-1.84a.645.645,0,0,1-.668-.666.651.651,0,0,1,.668-.668h5.08a.654.654,0,0,1,.479.189.663.663,0,0,1,.188.479.648.648,0,0,1-.187.479.66.66,0,0,1-.479.188h-1.828v5.8a.678.678,0,0,1-.207.5.686.686,0,0,1-.5.205A.67.67,0,0,1,15837.34,17849.105Zm-14,.205a.669.669,0,0,1-.5-.205.687.687,0,0,1-.205-.5v-6.434a.674.674,0,0,1,.207-.5.688.688,0,0,1,.5-.2h4.295a.7.7,0,0,1,.5.188.665.665,0,0,1,.2.488.636.636,0,0,1-.2.479.693.693,0,0,1-.5.18h-3.59v1.887h2.516a.7.7,0,0,1,.5.188.681.681,0,0,1,0,.959.7.7,0,0,1-.5.189h-2.516v1.949h3.59a.72.72,0,0,1,.5.18.636.636,0,0,1,.2.479.661.661,0,0,1-.2.49.712.712,0,0,1-.5.188Zm-6.865,0a.67.67,0,0,1-.5-.205.685.685,0,0,1-.2-.5v-6.434a.673.673,0,0,1,.205-.5.693.693,0,0,1,.5-.2h2.27a2.663,2.663,0,0,1,1.23.275,2.151,2.151,0,0,1,.852.775,2.079,2.079,0,0,1,.313,1.137,1.7,1.7,0,0,1-.285.957,1.831,1.831,0,0,1-.387.418,2.023,2.023,0,0,1,.689.52,1.953,1.953,0,0,1,.43,1.3,2.4,2.4,0,0,1-.34,1.271,2.362,2.362,0,0,1-.941.867,2.892,2.892,0,0,1-1.361.316Zm-.393-.4v0Zm1.1-.934h1.764a1.629,1.629,0,0,0,.68-.133.958.958,0,0,0,.434-.369,1.11,1.11,0,0,0,.158-.617.881.881,0,0,0-.582-.881,1.789,1.789,0,0,0-.689-.121h-1.764Zm0-3.457h1.564a1.2,1.2,0,0,0,.758-.221.749.749,0,0,0,.264-.641.739.739,0,0,0-.26-.635,1.275,1.275,0,0,0-.762-.219h-1.564Zm11.229-6.967-3.42,2.486,1.307-4.023-3.422-2.48h4.229l1.307-4.023,1.307,4.023h4.229l-3.42,2.48,1.307,4.023Z"
            transform="translate(-15790.341 -17817.549)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            stroke-width="1"
          />
        </g>
      </g>
    </svg>
  )
}

export const BetterOfferIcon = ({ ...rest }: SVGComponent) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="104.747"
      height="51.656"
      viewBox="0 0 104.747 51.656"
      {...rest}
    >
      <g
        id="best_offer_icon"
        data-name="best offer icon"
        transform="translate(27.713 21.36)"
      >
        <g id="Group_41" data-name="Group 41" transform="translate(0 -7.528)">
          <path
            id="Path_16317"
            data-name="Path 16317"
            d="M14850,17059.18l3.92-10.84-3.92-11.1h13.459a39.766,39.766,0,0,1,76.4,0h13.463l-3.918,11.1,3.918,10.84Z"
            transform="translate(-14877.002 -17021.855)"
            fill="#2f4858"
            stroke="rgba(0,0,0,0)"
            stroke-width="1"
          />
          <g id="Group_3474" data-name="Group 3474" transform="translate(0 -5)">
            <path
              id="Path_16318"
              data-name="Path 16318"
              d="M14871.227,17016.988h0l1.05-3.238-2.75-1.994h3.4l1.048-3.234,1.053,3.234h3.4l-2.751,1.994,1.051,3.234-2.753-2-2.747,2Z"
              transform="translate(-14849.527 -17004.143)"
              fill="#fff"
              stroke="rgba(0,0,0,0)"
              stroke-width="1"
            />
            <text
              id="Best_Plan"
              data-name="Best Plan"
              transform="translate(-1 11.521)"
              fill="#fff"
              font-size="12"
              font-family="Comfortaa-SemiBold, Comfortaa"
              font-weight="600"
            >
              <tspan x="-13.64" y="11">
                Best{" "}
              </tspan>
              <tspan x="-13.426" y="23">
                Plan
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const ServiceIcon = ({ ...rest }: SVGComponent) => {
  return (
    <svg
      id="service-icon"
      data-name="Group 66"
      xmlns="http://www.w3.org/2000/svg"
      width="132.196"
      height="129.804"
      viewBox="0 0 132.196 129.804"
      {...rest}
    >
      <g
        id="Group_67"
        className="icon"
        data-name="Group 67"
        transform="translate(0 0)"
      >
        <path
          id="Path_15900"
          className="icon-path icon__badge"
          data-name="Path 15900"
          d="M130.328,161.559a2.585,2.585,0,0,1-1.4-.411l-4.384-2.827-5.128.984a2.574,2.574,0,0,1-2.595-1.041l-3.014-4.315-5.128-.984a2.516,2.516,0,0,1-2.011-1.98l-1-5.03L101.275,143a2.48,2.48,0,0,1-1.06-2.543l1-5.041-2.88-4.3a2.491,2.491,0,0,1,0-2.751l2.88-4.3-1-5.04a2.48,2.48,0,0,1,1.1-2.569l4.348-2.812,1-5.142a2.528,2.528,0,0,1,2.119-2.01l3.9-.589a2.561,2.561,0,0,1,2.911,2.1,2.52,2.52,0,0,1-2.135,2.858l-2.119.32-.864,4.447a2.5,2.5,0,0,1-1.106,1.625l-3.82,2.467.869,4.4a2.473,2.473,0,0,1-.367,1.853l-2.533,3.782,2.533,3.782a2.473,2.473,0,0,1,.367,1.853l-.879,4.426,3.873,2.6a2.476,2.476,0,0,1,1.06,1.589l.874,4.386,4.466.858a2.543,2.543,0,0,1,1.613,1.041l2.652,3.8,4.508-.863a2.58,2.58,0,0,1,1.892.366l3.851,2.482,3.851-2.482a2.579,2.579,0,0,1,1.892-.366l4.471.858,2.513-3.751a2.536,2.536,0,0,1,1.638-1.081l4.508-.868.992-4.436a2.524,2.524,0,0,1,1.049-1.528l3.872-2.6-.879-4.426a2.473,2.473,0,0,1,.367-1.853l2.533-3.782-2.533-3.782a2.473,2.473,0,0,1-.367-1.853l.868-4.4-3.82-2.467a2.528,2.528,0,0,1-1.1-1.569L149.2,111.1l-4.5-.863a2.536,2.536,0,0,1-1.644-1.081l-2.513-3.751-4.477.853a2.541,2.541,0,0,1-1.887-.366l-3.851-2.482-3.851,2.482a2.541,2.541,0,0,1-1.887.366l-6.152-1.178a2.5,2.5,0,0,1-2.016-2.934,2.548,2.548,0,0,1,2.988-1.98l5.133.98,4.384-2.828a2.591,2.591,0,0,1,2.8,0l4.384,2.828,5.133-.98a2.549,2.549,0,0,1,2.616,1.081l2.864,4.274,5.1.98a2.528,2.528,0,0,1,2.011,1.934l1.127,5.183,4.378,2.827a2.479,2.479,0,0,1,1.1,2.569l-1,5.04,2.879,4.3a2.488,2.488,0,0,1,0,2.751l-2.879,4.3,1,5.041a2.48,2.48,0,0,1-1.06,2.543l-4.42,2.974-1.132,5.072a2.528,2.528,0,0,1-2,1.919l-5.1.98-2.864,4.279a2.571,2.571,0,0,1-2.621,1.081l-5.128-.984-4.384,2.827a2.585,2.585,0,0,1-1.4.411"
          transform="translate(-30.541 -31.755)"
          fill="#3f3f3f"
        />
        <path
          id="Path_15901"
          className="icon-path"
          data-name="Path 15901"
          d="M116.463,41.452l-12.779-9.328V9.274h.755a2.5,2.5,0,1,0,0-5.005H84.779a2.5,2.5,0,1,0,0,5.005h.9v9.711L60.342.487c-.03-.022-.064-.035-.095-.056a2.5,2.5,0,0,0-.253-.149c-.068-.035-.137-.066-.207-.095s-.155-.058-.235-.082a2.5,2.5,0,0,0-.25-.06c-.074-.014-.147-.024-.223-.032A2.436,2.436,0,0,0,58.816,0c-.076,0-.153,0-.229.011a2.413,2.413,0,0,0-.251.035C58.257.061,58.18.08,58.1.1a2.358,2.358,0,0,0-.241.084c-.072.028-.142.06-.212.1a2.625,2.625,0,0,0-.244.145c-.033.022-.07.036-.1.061L1.031,41.452a2.47,2.47,0,0,0-.527,3.5c.5.66,3.112.853,3.567.518L58.82,5.615,86.4,25.747a2.535,2.535,0,0,0,.625.456l12.249,8.942a2.54,2.54,0,0,0,.72.525l13.429,9.8a2.585,2.585,0,0,0,3.567-.518,2.471,2.471,0,0,0-.528-3.5M90.78,9.274h7.806V28.4l-7.806-5.7Z"
          transform="translate(0 0)"
          fill="#3f3f3f"
        />
        <path
          id="Path_15902"
          className="icon-path"
          data-name="Path 15902"
          d="M106.089,54.442a2.521,2.521,0,0,0-2.549,2.5V59.48l-43.2-31.51c-.028-.021-.061-.033-.089-.053A2.367,2.367,0,0,0,60,27.768c-.072-.038-.146-.071-.221-.1s-.138-.051-.209-.072a2.463,2.463,0,0,0-.285-.07c-.059-.011-.118-.019-.178-.025a2.551,2.551,0,0,0-.313-.017c-.058,0-.117,0-.175.009a2.526,2.526,0,0,0-.3.041c-.065.013-.128.028-.192.046a2.545,2.545,0,0,0-.268.091c-.072.028-.141.06-.211.1s-.144.079-.214.124c-.043.027-.088.045-.129.074L13.952,59.484V56.945a2.549,2.549,0,0,0-5.1,0v7.592c0,.015,0,.03,0,.045v54.836h-6.3a2.5,2.5,0,1,0,0,5H63.021a2.5,2.5,0,1,0,0-5H51.767V83.168a14.628,14.628,0,0,0-29.254,0V111.9a2.549,2.549,0,0,0,5.1,0V83.168a9.531,9.531,0,0,1,19.06,0v36.249H13.952V65.725L58.825,33.1,103.54,65.717v2.72a2.549,2.549,0,0,0,5.1,0V56.945a2.521,2.521,0,0,0-2.549-2.5"
          transform="translate(-0.001 -8.914)"
          fill="#3f3f3f"
        />
        <path
          id="Path_15903"
          className="icon-path"
          data-name="Path 15903"
          d="M88.1,67.383H74.294a2.5,2.5,0,1,0,0,5.005H88.1a2.5,2.5,0,1,0,0-5.005"
          transform="translate(-22.378 -21.855)"
          fill="#3f3f3f"
        />
        <path
          id="Path_15905"
          className="icon-path icon__star--inner-color"
          data-name="Path 15905"
          d="M133.637,139.244l2.771,2.858a2.459,2.459,0,0,1,.687,2.025l-.506,4.132,3.82-1.7a2.547,2.547,0,0,1,2.109,0l3.738,1.66-.568-4.051a2.472,2.472,0,0,1,.682-2.066l2.781-2.868-3.965-.751a2.563,2.563,0,0,1-1.763-1.274l-1.959-3.568-1.96,3.568a2.541,2.541,0,0,1-1.768,1.274Z"
          transform="translate(-41.682 -43.344)"
          fill="#36462d"
          stroke="#36462d"
        />
        <path
          id="Path_15904"
          className="icon-path icon__star"
          data-name="Path 15904"
          d="M130.063,151.187a2.59,2.59,0,0,1-1.51-.482,2.484,2.484,0,0,1-1.024-2.32l.9-7.376-5.17-5.335a2.471,2.471,0,0,1-.584-2.492,2.552,2.552,0,0,1,1.955-1.7l7.506-1.4,3.629-6.614a2.675,2.675,0,0,1,4.487,0l3.629,6.619,7.362,1.391a2.544,2.544,0,0,1,1.949,1.7,2.461,2.461,0,0,1-.584,2.487l-5.154,5.315,1.034,7.356a2.482,2.482,0,0,1-1,2.345,2.588,2.588,0,0,1-2.58.274l-6.9-3.066-6.9,3.066a2.548,2.548,0,0,1-1.054.224m.125-15.635,2.77,2.858a2.457,2.457,0,0,1,.687,2.025l-.506,4.132,3.82-1.7a2.547,2.547,0,0,1,2.109,0l3.738,1.66-.568-4.051a2.471,2.471,0,0,1,.681-2.066l2.781-2.868-3.965-.751a2.561,2.561,0,0,1-1.762-1.274l-1.959-3.568-1.96,3.568a2.541,2.541,0,0,1-1.768,1.274Z"
          transform="translate(-38.227 -39.653)"
          fill="#3f3f3f"
        />
      </g>
    </svg>
  )
}

export const GoogleIcon = ({ ...rest }: SVGComponent) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 57 57"
      {...rest}
    >
      <g id="social_logo" data-name="social logo">
        <circle
          id="Ellipse_1"
          data-name="Ellipse 1"
          cx="28.5"
          cy="28.5"
          r="28.5"
          className="fr-google-review__icon"
        />
        <path
          id="Path_15865"
          data-name="Path 15865"
          d="M16.091,14.435V18.77H26.455a9.192,9.192,0,0,1-2.361,5.464,10.611,10.611,0,0,1-8,3.173A11.375,11.375,0,0,1,4.723,15.88,11.375,11.375,0,0,1,16.091,4.353a11.019,11.019,0,0,1,7.808,3.1l3.049-3.049A14.97,14.97,0,0,0,16.091,0,16.084,16.084,0,0,0,0,15.862,16.084,16.084,0,0,0,16.091,31.725,14.539,14.539,0,0,0,27.16,27.283c2.855-2.855,3.754-6.891,3.754-10.134a13.938,13.938,0,0,0-.229-2.714Z"
          transform="translate(12.643 12)"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

export const PpcPhoneIcon = ({ ...rest }: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33.748"
    height="41"
    viewBox="0 0 33.748 41"
    {...rest}
  >
    <g data-name="Group 3432" transform="translate(0.266 0.266)">
      <path
        className="brand--fill"
        d="M21.542,12.4V10.935A2.935,2.935,0,0,0,18.608,8H3.935A2.935,2.935,0,0,0,1,10.935V12.4Z"
        transform="translate(-0.266 -2.131)"
      />
      <path
        className="brand--stroke"
        d="M21.542,12.4V10.935A2.935,2.935,0,0,0,18.608,8H3.935A2.935,2.935,0,0,0,1,10.935V12.4Z"
        stroke-miterlimit="10"
        transform="translate(-0.266 -2.131)"
      />
      <path
        className="brand--fill"
        d="M1,49v2.935a3.269,3.269,0,0,0,2.935,2.935H18.608a3.269,3.269,0,0,0,2.935-2.935V49Z"
        transform="translate(-0.266 -15.136)"
      />
      <path
        className="brand--stroke"
        d="M1,49v2.935a3.269,3.269,0,0,0,2.935,2.935H18.608a3.269,3.269,0,0,0,2.935-2.935V49Z"
        stroke-miterlimit="10"
        transform="translate(-0.266 -15.136)"
      />
      <rect
        className="color--fill"
        height="26"
        transform="translate(0.481 7.916)"
        width="21"
      />
      <path
        className="brand--stroke"
        d="M21.542,23.537v16.14H1V14H21.542v4.4"
        stroke-miterlimit="10"
        transform="translate(-0.266 -5.813)"
      />
      <line
        className="brand--stroke"
        stroke-miterlimit="10"
        transform="translate(9.092 36.916)"
        x2="4"
      />
      <path
        className="color--fill"
        d="M37.477,3.2V14.977a2.163,2.163,0,0,1-2.164,2.164H23.445l-4.466,5.673a.734.734,0,0,1-1.31-.454V17.14H16.213A2.22,2.22,0,0,1,14,14.927V3.2A2.2,2.2,0,0,1,16.2,1H35.276a2.2,2.2,0,0,1,2.2,2.2"
        transform="translate(-4.995 -0.266)"
      />
      <path
        className="brand--stroke"
        d="M37.477,3.2V14.977a2.163,2.163,0,0,1-2.164,2.164H23.445l-4.466,5.673a.734.734,0,0,1-1.31-.454V17.14H16.213A2.22,2.22,0,0,1,14,14.927V3.2A2.2,2.2,0,0,1,16.2,1H35.276A2.2,2.2,0,0,1,37.477,3.2Z"
        stroke-miterlimit="10"
        transform="translate(-4.995 -0.266)"
      />
      <path
        className="brand--stroke"
        d="M0,0H1"
        stroke-linecap="round"
        transform="translate(16.814 8.581)"
      />
      <path
        className="brand--stroke"
        d="M0,0H1"
        stroke-linecap="round"
        transform="translate(20.657 8.581)"
      />
      <path
        className="brand--stroke"
        d="M0,0H1"
        stroke-linecap="round"
        transform="translate(24.5 8.581)"
      />
    </g>
  </svg>
)
